import asStateAwareArea from 'mapping/asStateAwareArea';
import {
  AreaType,
  IArea,
  IGateEvent,
  IMappableSetting,
  IStateAwareArea,
} from 'types/map';

export default class Area implements IArea {
  readonly areaKey: string;

  readonly canChangeOutfit: boolean;

  readonly canMoveTo: boolean;

  readonly childAreas: IArea[];

  readonly description: string;

  readonly discovered: boolean;

  readonly gateEvent?: IGateEvent;

  readonly hideName: boolean;

  readonly hitbox: number[][] | undefined;

  readonly id: number;

  readonly image: string;

  readonly labelX: number | undefined;

  readonly labelY: number | undefined;

  readonly mainDestinationHitbox: number[][] | undefined;

  readonly mainDestinationSelectionSpriteTopLeftX: number | undefined;

  readonly mainDestinationSelectionSpriteTopLeftY: number | undefined;

  readonly mainDestinationSpriteTopLeftX: number | undefined;

  readonly mainDestinationSpriteTopLeftY: number | undefined;

  readonly moveMessage: string;

  readonly name: string;

  readonly needsProminentTravelButton: boolean;

  readonly playerMarkerAnchorX: number | undefined;

  readonly playerMarkerAnchorY: number | undefined;

  readonly premiumSubRequired: boolean;

  readonly shouldShowTravelButton: boolean;

  readonly showOps: boolean;

  readonly selectionSpriteTopLeftX: number | undefined;

  readonly selectionSpriteTopLeftY: number | undefined;

  readonly spriteTopLeftX: number | undefined;

  readonly spriteTopLeftY: number | undefined;

  readonly territorialWaterSpriteTopLeftX: number | undefined;

  readonly territorialWaterSpriteTopLeftY: number | undefined;

  readonly travelButtonLabel: string | undefined;

  readonly type: AreaType;

  readonly unavailableDescription: string;

  readonly unlocked: boolean;

  readonly visitable: boolean | undefined;

  readonly zIndex: number;

  constructor(obj: IArea) {
    this.areaKey = obj.areaKey;
    this.canChangeOutfit = obj.canChangeOutfit;
    this.canMoveTo = obj.canMoveTo;
    this.childAreas = obj.childAreas;
    this.description = obj.description;
    this.discovered = obj.discovered;
    this.gateEvent = obj.gateEvent;
    this.hideName = obj.hideName;
    this.hitbox = obj.hitbox;
    this.id = obj.id;
    this.image = obj.image;
    this.labelX = obj.labelX;
    this.labelY = obj.labelY;
    this.mainDestinationHitbox = obj.mainDestinationHitbox;
    this.mainDestinationSelectionSpriteTopLeftX = obj.mainDestinationSelectionSpriteTopLeftX;
    this.mainDestinationSelectionSpriteTopLeftY = obj.mainDestinationSelectionSpriteTopLeftY;
    this.mainDestinationSpriteTopLeftX = obj.mainDestinationSpriteTopLeftX;
    this.mainDestinationSpriteTopLeftY = obj.mainDestinationSpriteTopLeftY;
    this.moveMessage = obj.moveMessage;
    this.name = obj.name;
    this.needsProminentTravelButton = obj.needsProminentTravelButton ?? false;
    this.playerMarkerAnchorX = obj.playerMarkerAnchorX;
    this.playerMarkerAnchorY = obj.playerMarkerAnchorY;
    this.premiumSubRequired = obj.premiumSubRequired;
    this.showOps = obj.showOps;
    this.shouldShowTravelButton = obj.shouldShowTravelButton ?? true;
    this.selectionSpriteTopLeftX = obj.selectionSpriteTopLeftX;
    this.selectionSpriteTopLeftY = obj.selectionSpriteTopLeftY;
    this.spriteTopLeftX = obj.spriteTopLeftX;
    this.spriteTopLeftY = obj.spriteTopLeftY;
    this.territorialWaterSpriteTopLeftX = obj.territorialWaterSpriteTopLeftX;
    this.territorialWaterSpriteTopLeftY = obj.territorialWaterSpriteTopLeftY;
    this.travelButtonLabel = obj.travelButtonLabel;
    this.type = obj.type;
    this.unavailableDescription = obj.unavailableDescription;
    this.unlocked = obj.unlocked;
    this.visitable = obj.visitable;
    this.zIndex = obj.zIndex;
  }

  toStateAwareArea: (
    areas: IArea[],
    setting: IMappableSetting,
    currentArea: IArea | undefined,
  ) => IStateAwareArea = (areas, setting, currentArea) => asStateAwareArea(this, areas, setting, currentArea);
}